"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var input_1 = require("../input");

var Animate_1 = require("../../Animate");

exports.default = function (_a) {
  var _b = _a.label,
      label = _b === void 0 ? "LET'S START" : _b,
      _c = _a.hint,
      hint = _c === void 0 ? 'What is your email address?' : _c,
      className = _a.className,
      value = _a.value,
      onChange = _a.onChange;
  return react_1.default.createElement("div", {
    className: className
  }, react_1.default.createElement(Animate_1.SlideInUp, null, react_1.default.createElement("h4", {
    className: 'mt-4'
  }, label)), react_1.default.createElement(Animate_1.SlideInUp, null, react_1.default.createElement("p", {
    className: 'mb-4'
  }, hint)), react_1.default.createElement("div", {
    className: 'row'
  }, react_1.default.createElement("div", {
    className: 'offset-xs-2 col-xs-8 col-sm-12'
  }, react_1.default.createElement("div", {
    className: 'input-group my-4'
  }, react_1.default.createElement("input", {
    autoFocus: true,
    value: value,
    onChange: input_1.getTargetValue(onChange),
    id: 'email',
    type: 'email',
    name: 'email',
    placeholder: 'Email Address',
    className: 'form-control bg-transparent'
  })))));
};